import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page',
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'news',
        loadChildren: () => import('./views/news-view/news-view.module').then(m => m.NewsViewModule)
      },
      {
        path: 'studio',
        loadChildren: () => import('./views/studio-view/studio-view.module').then(m => m.StudioViewModule)
      },
      {
        path: 'physio',
        loadChildren: () => import('./views/physio-view/physio-view.module').then(m => m.PhysioViewModule)
      },
      {
        path: 'members',
        loadChildren: () => import('./views/members-view/members-view.module').then(m => m.MembersViewModule)
      },
      {
        path: 'kurse',
        loadChildren: () => import('./views/courses-view/courses-view.module').then(m => m.CourseViewModule)
      },
      {
        path: 'about',
        loadChildren: () => import('./views/about-view/about-view.module').then(m => m.AboutViewModule)
      },
      {
        path: 'wellness',
        loadChildren: () => import('./views/wellness-view/wellness-view.module').then(m => m.WellnessViewModule)
      },




      {
        path: 'base',
        loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      },
      {
        path: 'buttons',
        loadChildren: () => import('./views/buttons/buttons.module').then(m => m.ButtonsModule)
      },
      {
        path: 'charts',
        loadChildren: () => import('./views/chartjs/chartjs.module').then(m => m.ChartJSModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'theme',
        loadChildren: () => import('./views/theme/theme.module').then(m => m.ThemeModule)
      },
      {
        path: 'widgets',
        loadChildren: () => import('./views/widgets/widgets.module').then(m => m.WidgetsModule)
      }
    ]
  },
  {
    path: "page/kurse",
    loadChildren: () => import("./views/courses-view/courses-view.module").then((m) => m.CourseViewModule),
    data: {
      external: true
    }
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
